export const getToken = () => localStorage.getItem("jwt-token-ds");


export const saveToken = (jwt) => {
  localStorage.setItem("jwt-token-ds", jwt);
}


export const removeToken = () => localStorage.removeItem("jwt-token-ds");

export const getTokenInfo = () => {
  try {
    const token = getToken();
    if (token) {
      const payload = window.atob(token.split(".")[1]);
      return JSON.parse(payload);
    }
  } catch (error) {
    console.error(error);
  }
};

export const isAuthed = () => {
  const token_info = getTokenInfo();

  if (token_info && token_info.exp > Math.round(new Date() / 1000)) {
    return token_info.id;
  } else {
    console.log('Did not find a valid token');
    return false;
  }
};